import { URL } from "./URL";
import { useQuery } from "@tanstack/react-query";
import API from "./api";

export const getResults = (token) => {
	return API.get(URL.RESULT.GET_RESULTS, {
		headers: {
			Authorization: `Token ${token}`,
		},
	});
};

export const postResult = (token, resultado) => {
	return API.post(URL.RESULT.POST_RESULT, resultado, {
		headers: { Authorization: `Token ${token}` },
	});
};

export const getResultByID = (token, id) => {
	return API.get(`${URL.RESULT.GET_RESULT_BY_ID}${id}`, {
		headers: { Authorization: `Token ${token}` },
	});
};

export const deleteResultByID = (token, id) => {
	return API.delete(`${URL.RESULT.GET_RESULT_BY_ID}${id}`, {
		headers: { Authorization: `Token ${token}` },
	});
};


const getData = async (token) => {
	const { data } = await getResults(token);
	return data;
};

export const getDataByID = async (token, id) => {
	const { data } = await getResultByID(token, id);
	return data;
};

// Custom Hook


export const useResult = (token) => {
	return useQuery(["my-results"], () => getData(token));
};

export const useResultByID = (token, id) => {
	return useQuery(["my-results-id", id], () => getDataByID(token, id));
};
